module.exports = __webpack_public_path__ + "img/photo_2023-11-22 13.51.25.71efc3bd.jpg";